import { useQuery } from 'react-query';
import { model } from '..';
import { Dimension } from '../dimensions';

export const queryKey = () => 'goal-dimensions';

export const useDimensionsList = () =>
  useQuery<Array<Dimension>>(queryKey(), () => model().getList());
